import {isList} from "./isList.js";
export const hasListChild = (editor, node) => node.children.some(isList);
